import {Observable} from 'rxjs';
import {TakerDataService} from './takerData.service';
import {Injectable} from '@angular/core';
import {DataRequestOptions, PollResponse, PollResultsResponse, QuestionsResponse} from "../../models";

@Injectable()
export class TakerService {

    constructor(public dataService: TakerDataService) {
    }

    getPoll(pollId: number, scriptId: string, options: DataRequestOptions): Observable<PollResponse> {
        return this.dataService.getPoll(pollId, scriptId, options);
    }

    startPoll(pollId: number, options: DataRequestOptions, scriptId: string): Observable<QuestionsResponse> {
        return this.dataService.startPoll(pollId, options, scriptId);
    }

    getQuestions(pollId: number, options: DataRequestOptions, scriptId: string, questSetNum?: number): Observable<QuestionsResponse> {
        return this.dataService.getQuestions(pollId, options, scriptId, questSetNum);
    }

    submit(obj: any, pollId: number, options: DataRequestOptions, scriptId: string, questSetNum: number,
           submitAndNext: boolean): Observable<QuestionsResponse> {

        return this.dataService.submit(obj, pollId, options, scriptId, questSetNum, submitAndNext);
    }

    getPollResults(pollId: number, options: DataRequestOptions): Observable<PollResultsResponse> {
        return this.dataService.getPollResults(pollId, options);
    }
}
